export const setDocumentHeaders = (title, description, image) => {
    if(title) document.title = title;
    if(description) document.querySelector('meta[name="description"]').setAttribute("content", description);
    //if(title) document.querySelector('meta[property="og:title"]').setAttribute("content", title);
    //if(description) document.querySelector('meta[property="og:description"]').setAttribute("content", description);
    //if(image) document.querySelector('meta[property="og:image"]').setAttribute("content", image);
    //if(title) document.querySelector('meta[property="twitter:title"]').setAttribute("content", title);
    //if(description) document.querySelector('meta[property="twitter:description"]').setAttribute("content", description);
    //if(image) document.querySelector('meta[property="twitter:image"]').setAttribute("content", image);
}